<template>
  <div id="app">
       <div style="background:#fff;margin-bottom:28px;" id="navba">
    <div  style="padding-left:0px;">
    <nav  style="padding-left:0px;">
      <div class="navAjs"  >
          <div style="display: flex; align-items: center;">
            <a  href="https://www.lefisc.com.br"> <img src="https://www.lefisc.com.br/monitoramentoncm/img/logo.png" style="width:115px;height:27px;"></a>
            <p @click="pag" style="cursor:pointer;font-size:14px">LGPD: Lei Geral de Proteção de Dados</p>
          </div>     
      
      </div>
    </nav>
    </div>
    </div> 
    <br />
    <Principal />
   
  </div>
</template>

<script>
import Principal from './screens/Principal.vue'
export default {
  name: 'App',
  components:{Principal },  
  
  methods:{
    pag(){
      this.$router.push({name:'protecao'})
    },    
  },
}
</script>

<style>
.sumarioNone{
    display: none  !important;
}
.sumariosP{
    display: flex;
    flex-direction: column;
    width: 100%;
    text-align: justify;
    padding-bottom: 16px;
}
.suma{
    position: absolute;
    background: #fff;
    color: #000;
    width: 180px;
    font-size: 12px;
    border: 0px;
    right: 5px;    
    top: -226px;
    box-shadow: rgb(100 100 111 / 20%) 0px 7px 29px 0px;
    border-radius: 5px;
}
.suma p{
    margin-bottom: 0px;
      border-bottom: 1px solid #4A154B;
      display: flex;
      justify-content: center;
      padding: 5px
}
.suma p:last-child{
    border:none
}
.suma2{
     background: #4A154B;
     width: 150px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    font-size: 14px;
    border-radius: 5px;
}
.sumarioTo{        
    font-weight: bold;
    color: #fff;
    border-radius: 10px;
    position: fixed;
    bottom: 10px;
    z-index: 10;
    right: 15px;
    padding: 5px;
    cursor: pointer;
}
.navAjs{
  display:flex;height:60px;align-items: center;justify-content: space-between;
  max-width: 1290px; 
  margin:0 auto;
}
.navAjs a{
  text-decoration: none !important;
color:#383838;
  
}
.navAjs p{
  position: relative;
  margin-left:24px;
  display: flex;
  justify-content: space-between;
  color: #383838;
  font-size: 19px !important;
  font-weight: 600 !important;
  margin-top: 17px;
}
.navAjs p::before{
  content: "";
  position: absolute;
  height: 25px;
  width: 1px;
  top:1px;
  left: -14px;
  background: grey;
}
li{
  position: relative;
}
li.active a{
  color: #383838;
}
li.active a::after{
  content: '';
  position: absolute;
  left:-3px;
  top:13px;  
  width: 1px;
  height: 25px;
  background: #000;
  border-left: .7px solid grey;
}
@media screen and (max-width: 600px) {
  #app {font-size: 0.9em;}
}
#app {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
  padding: 0;
  min-height: 94vh;
  margin: 0;
  color:#6A6A6A;
  
}
html, body{
  scroll-behavior: smooth !important;
}
.hidden{
  overflow-y: hidden;
}
.newColor {
  background: #EFF3F5 !important;
}
html,body {
  height: 100%;
}
html::-webkit-scrollbar {
  width: 10px !important; 
}
html::-webkit-scrollbar-track {
  background-color: rgb(0, 0, 0, 0);
}
html::-webkit-scrollbar-thumb {
  background: #4e4e4e;
  border-radius: 25px;
}
</style>
